export enum BonusType {
  FreeSpin = 'FREE_SPINS_BONUS',
  SpinOfTheDay = 'SPIN_OF_THE_DAY_BONUS'
}

export enum BonusGameTypeVariant {
  SpinOfDayStandard = '',
  SpinOfDayFreeToPlay = '1',
  BonusRound = '2'
}

export enum BonusStatus {
  Available = 'BONUS_AVAILABLE_TO_PLAY',
  Playing = 'BONUS_PLAYING',
  Completed = 'BONUS_COMPLETED',
  Expired = 'BONUS_EXPIRED',
  Paused = 'BONUS_REVOKED_TEMPLATE_PAUSE'
}

export interface CasinoBonusGame {
  bonusId: string;
  bonusCampaignId: string;
  gameURL: string;
}

export interface SpinOfDayData extends CasinoBonusGame {
  status: BonusStatus;
  numberOfSpins: number;
  expiryTime: number;
  theme: string;
  themeId: string;
  variantType: string;
}
